<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="userDropdown && userDropdown.length">
          <SelectVue
              v-model="filters.userId"
              :options="userDropdown"
              :is-clear="true"
              :placeholder="$t('general.employee')"/>
        </div>
      </div>
      <div v-if="statusDropdown && statusDropdown.length" class="col-lg-2 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.status"
            :options="statusDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.status')"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"
            :placeholder="$t('general.start_date')"/>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            :placeholder="$t('general.end_date')"/>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-12">
        <BaseCheckbox
            v-model="filters.thisWeek"
            :label="$t('general.this_week')"
            :labelPosition="'right'"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-if="!loading">{{ $t('general.button.search') }}</span>
          <span v-else>{{ $t('general.button.search_in_progress') }}</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  userDropdown: {
    type: Array,
    required: true,
  },
  statusDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits([ 'search' ]);

const { filters }  = toRefs(props);
const userDropdown = toRefs(props)[ 'userDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
